import { Form } from 'factorial-form'

class BasicTimeoffPolicyForm extends Form {
  constructor(values: {}) {
    super(values, {
      name: 'string',
      description: 'string',
    })
  }
}

export default BasicTimeoffPolicyForm
